import { selectToken } from '@caudena/web-platform'
import styled from '@emotion/styled';

export const FooterProgress = styled.div`
  width: 80%;
  max-width: 1200px;
`

export const EditableTag = styled.input`
  font: ${({ theme }) => selectToken(theme, 'typographyHeading100NormalFont')};
  color: ${({ theme }) =>
    selectToken(theme, 'typographyBaseOnBackgroundBaseColor')};
  padding: 0;
  outline: none;
  background: transparent;
`
